import { createAlarmModel } from '@akin-home/alarms';
import { createAlertModel } from '@akin-home/alerts';
import { getDateDifference } from '@akin-home/dates';
import { createEventModel } from '@akin-home/events';
import { createGoalModel } from '@akin-home/goals';
import { createMealModel } from '@akin-home/meals';
import {
  addRecurrenceEndDate,
  createRecurrenceID,
  createRecurrenceRule,
  createRecurringItem,
  flattenWithRecurrences,
  generateRecurrenceDates,
  generateRecurrences,
  getCustomRecurrenceData,
  getDateFromRecurrenceID,
  getDateStringFromRecurrenceID,
  getLatestRecurrenceDate,
} from '@akin-home/recurrence';
import produce from 'immer';
import { CalendarItemUnion } from '../calendar/types';
import { CheckListItem } from './types';

export const getId = (i: { id?: string }): string => i.id as string;

// ----- Checklist Setting -----
export const setChecklistItem = produce(
  (item: CalendarItemUnion, checklistItem: CheckListItem) => {
    if (!("checklist" in item)) return
    
    const i = item.checklist.find((i) => i.id === checklistItem.id);

    if (i) {
      i.checked = checklistItem.checked;
    } else {
      item.checklist.push(checklistItem);
    }
  }
);

export const removeKeyFromObject = <T extends string | number>(
  obj: any,
  key: T
): any => {
  const { [key]: removed, ...rest } = obj;
  return rest;
};

export {
  addRecurrenceEndDate,
  createAlarmModel,
  createAlertModel,
  createEventModel,
  createGoalModel,
  createMealModel,
  createRecurrenceID,
  createRecurrenceRule,
  createRecurringItem,
  flattenWithRecurrences,
  generateRecurrenceDates,
  generateRecurrences,
  getCustomRecurrenceData,
  getDateDifference,
  getDateFromRecurrenceID,
  getDateStringFromRecurrenceID,
  getLatestRecurrenceDate,
};

